export const publicApiPath = '/api/public';
